import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUPCONTRACT_LOAD_BY_TRIAL_GROUP_ID,
    ACTION_TRIALGROUPCONTRACT_LOAD_BY_ID,

    ACTION_TRIALGROUPCONTRACT_SAVE,

    ACTION_TRIALGROUPCONTRACT_CREATE,

    ACTION_TRIALGROUPCONTRACT_DELETE,

    ACTION_TRIALGROUPCONTRACT_VALIDATE,

    ITrialGroupContractLoadByTrialGroupIdAction,
    ITrialGroupContractLoadByIdAction,
    ITrialGroupContractLoadFailureAction,
    ITrialGroupContractLoadSuccessAction,

    ITrialGroupContractSaveAction,
    ITrialGroupContractSaveSuccessAction,
    ITrialGroupContractSaveFailureAction,

    ITrialGroupContractCreateAction,
    ITrialGroupContractCreateSuccessAction,
    ITrialGroupContractCreateFailureAction,

    ITrialGroupContractDeleteAction,
    ITrialGroupContractDeleteSuccessAction,
    ITrialGroupContractDeleteFailureAction,

    ITrialGroupContractValidateAction,
    ITrialGroupContractValidateSuccessAction,
    ITrialGroupContractValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialGroupContract";
import { trialGroupContractApi } from "../services/trialGroupContract";

export const
    getTrialGroupContractByTrialGroupIdEpic = (action$): Observable<ITrialGroupContractLoadSuccessAction | ITrialGroupContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPCONTRACT_LOAD_BY_TRIAL_GROUP_ID)
            .mergeMap((action: ITrialGroupContractLoadByTrialGroupIdAction) => {
                return trialGroupContractApi
                    .getTrialGroupContractByTrialGroupId(action.trialGroupId)
                    .map(response =>
                        LoadSuccess(response.trialGroupContract, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupContractByIdEpic = (action$): Observable<ITrialGroupContractLoadSuccessAction | ITrialGroupContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPCONTRACT_LOAD_BY_ID)
            .mergeMap((action: ITrialGroupContractLoadByIdAction) => {
                return trialGroupContractApi
                    .getTrialGroupContractById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialGroupContract, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialGroupContractEpic = (action$): Observable<ITrialGroupContractSaveSuccessAction | ITrialGroupContractSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPCONTRACT_SAVE)
            .mergeMap((action: ITrialGroupContractSaveAction) => {
                return trialGroupContractApi
                    .setTrialGroupContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialGroupContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialGroupContractEpic = (action$): Observable<ITrialGroupContractCreateSuccessAction | ITrialGroupContractCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPCONTRACT_CREATE)
            .mergeMap((action: ITrialGroupContractCreateAction) => {
                return trialGroupContractApi
                    .createTrialGroupContract(action.trialGroupId)
                    .map(response =>
                        CreateSuccess(
                            response.trialGroupContract,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialGroupContractEpic = (action$): Observable<ITrialGroupContractValidateSuccessAction | ITrialGroupContractValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPCONTRACT_VALIDATE)
            .mergeMap((action: ITrialGroupContractValidateAction) => {
                return trialGroupContractApi
                    .validateTrialGroupContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialGroupContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    },
    deleteTrialGroupContractEpic = (action$): Observable<ITrialGroupContractDeleteSuccessAction | ITrialGroupContractDeleteFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPCONTRACT_DELETE)
            .mergeMap((action: ITrialGroupContractDeleteAction) => {
                return trialGroupContractApi
                    .deleteTrialGroupContract(action.id)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    }